import { Button, notification, Select, Input, Form, InputNumber, DatePicker, Space, Modal, List, Typography, Image, Upload, Card, Row, Col, Avatar, Tag, Table, Checkbox } from "antd"
import Title from "antd/es/typography/Title"
import {
    GetretreatByID,
    UpdateRetreat,
    CreateRetreatLesson,
    CreateRetreatMonk, DeleteRetreatMonk,
    DeleteRetreatLesson,
    GetRetreatLessons,
    GetRetreatMonks,
    GetAccountsBySize,
    GetLessonsBySize,
    GetFeedbackbyRetreatID,
    GetToolsBySize
} from "../../../api/AdminService"
import { useNavigate, useParams } from "react-router-dom"
import dayjs from "dayjs"
import { useEffect, useState } from "react"
import { Option } from "antd/es/mentions"
import { ArrowLeftOutlined, MinusCircleOutlined, PlusOutlined, UploadOutlined } from "@ant-design/icons"
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Bar } from 'react-chartjs-2';
const { Link } = Typography;

const FeedbackBarChart = ({ feedback }) => {

    const sum = feedback.reduce((accumulator, currentValue) => {
        accumulator.retreatRating += currentValue.retreatRating || 0;
        accumulator.monkRating += currentValue.monkRating || 0;
        accumulator.roomRating += currentValue.roomRating || 0;
        accumulator.foodRating += currentValue.foodRating || 0;
        return accumulator;
    }, { retreatRating: 0, monkRating: 0, roomRating: 0, foodRating: 0 });

    const average = {
        retreatRating: sum.retreatRating / feedback.length,
        monkRating: sum.monkRating / feedback.length,
        roomRating: sum.roomRating / feedback.length,
        foodRating: sum.foodRating / feedback.length,
    };

    const data = {
        labels: ['Retreat Rating', 'Monk Rating', 'Room Rating', 'Food Rating'],
        datasets: [
            {
                label: 'Star',
                data: [
                    average.retreatRating,
                    average.monkRating,
                    average.roomRating,
                    average.foodRating,
                ],
                backgroundColor: [
                    '#FF6384', // Bright Red
                    '#36A2EB', // Bright Blue
                    '#FFCE56', // Bright Yellow
                    '#4BC0C0', // Bright Teal
                ],
            },
        ],
    };

    const options = {
        indexAxis: 'y',
        scales: {
            x: {
                beginAtZero: true,
                max: 5,
            },
        },
    };

    return <Bar data={data} options={options} />;
};


const AdminDetailRetreat = () => {
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const { id } = useParams();
    const [Edit, setEdit] = useState(false)
    const [Retreat, setRetreat] = useState([]);


    const [Lesson, setLesson] = useState([]);
    const [retreatLessons, setRetreatLessons] = useState([]);
    const [selectedLesson, setSelectedLesson] = useState(null);
    const [Feedback, setFeedBack] = useState([]);
    const [Monk, setMonk] = useState([]);
    const [retreatMonks, setRetreatMonks] = useState([]);
    const [selectedMonk, setSelectedMonk] = useState(null);
    const [ToolData, setToolData] = useState([]);

    const [description, setDescription] = useState('');

    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedTools, setSelectedTools] = useState([]);
    const [isAddMonkModalVisible, setIsAddMonkModalVisible] = useState(false);

    const handleEditClick = () => {
        if (Retreat?.status === "InActive") {
            notification.error({
                message: 'The retreat has ended',
            });
        } else {
            setEdit(true);
        }
    };

    const getFeedbackForRetreat = (id) => {
        GetFeedbackbyRetreatID(id).then(res => {
            if (res.status === 200) {
                console.log(res.data)
                setFeedBack(res.data);

            }
        })
    }

    const getLessons = () => {
        try {
            GetLessonsBySize(1000).then(res => {
                if (res.status === 200) {
                    console.log(res.data.data)
                    setLesson(res.data.data)
                }
            })
        } catch (err) {
            console.log(err)
        }
    }
    const RetreatLessons = (id) => {
        GetRetreatLessons(id).then(res => {
            if (res.status === 200) {
                console.log(res.data.data)
                setRetreatLessons(res.data.data);
                console.log(retreatLessons)
            }
        })
    }

    const handleAddLesson = () => {
        if (selectedLesson) {
            CreateRetreatLesson(id, selectedLesson).then(res => {
                if (res.status === 201) {
                    notification.success({
                        message: "Lesson added successfully"
                    });
                    RetreatLessons(id);
                    setSelectedLesson(null);
                }
            }).catch(err => {
                console.log(err);
                notification.error({
                    message: `${err.response.data.message}`
                });
            });
        }
    };

    const handleDeleteLesson = (lessonId) => {
        DeleteRetreatLesson(lessonId).then(res => {
            if (res.status === 200) {
                notification.success({
                    message: "Lesson deleted successfully"
                });
                RetreatLessons(id);
            }
        }).catch(err => {
            console.log(err);
            notification.error({
                message: `${err.response.data.message}`
            });
        });
    };

    const getTools = () => {
        try {
            GetToolsBySize(1000).then(res => {
                if (res.status === 200) {
                    console.log(res.data.data)
                    setToolData(res.data.data)
                }
            })
        } catch (err) {
            console.log(err)
        }
    }

    const getAccounts = (size) => {
        try {
            GetAccountsBySize(size).then(res => {
                if (res.status === 200) {
                    const monks = res.data.data.filter(account => account.role === 'Monk');
                    console.log(monks);
                    setMonk(monks);
                }
            })
        } catch (err) {
            console.log(err)
        }
    }
    const RetreatMonks = (id) => {
        GetRetreatMonks(id).then(res => {
            if (res.status === 200) {
                console.log(res.data.data)
                setRetreatMonks(res.data.data);
                console.log(retreatMonks)
            }
        })
    }

    const confirmAddMonk = () => {
        setLoading(true);
        if (selectedMonk && retreatMonks.length < 1) {
            CreateRetreatMonk(id, selectedMonk).then(res => {
                if (res.status === 201) {
                    notification.success({
                        message: "Monk added successfully"
                    });
                    RetreatMonks(id);
                    setLoading(false);
                    setIsAddMonkModalVisible(false)
                }
            }).catch(err => {
                console.log(err);
                notification.error({
                    message: `${err.response.data.message}`
                });
                setLoading(false);
            });
        } else {
            notification.error({
                message: `Only one Monk for Retreat`
            });
            setLoading(false);
        }
    };

    const handleDeleteMonk = (MonkId) => {
        DeleteRetreatMonk(MonkId).then(res => {
            if (res.status === 200) {
                notification.success({
                    message: "Monk deleted successfully"
                });
                RetreatMonks(id);
            }
        }).catch(err => {
            console.log(err);
            notification.error({
                message: `${err.response.data.message}`
            });
        });
    };



    const GetRetreatID = (id) => {
        console.log(id)
        GetretreatByID(id).then(res => {
            if (res.status === 200) {
                console.log(res.data)
                setRetreat(res.data)
                form.setFieldsValue({
                    name: res.data?.name,
                    cost: res.data?.cost,
                    capacity: res.data?.capacity,
                    duration: res.data?.duration,
                    startDate: dayjs(res.data?.startDate, "YYYY-MM-DD"),
                    endDate: dayjs(res.data?.endDate, "YYYY-MM-DD"),
                    status: res.data?.status,
                    description: res.data?.description,
                    retreatImages: res.data?.retreatImages,
                    retreatDocuments: res.data?.retreatDocuments,
                    retreatLearningOutcomes: res.data?.retreatLearningOutcomes,
                    retreatMonks: res.data?.retreatMonks,
                    retreatTools: res.data?.retreatTools
                })
                setDescription(res.data?.description)
            }
        })
    }



    useEffect(() => {
        getLessons();
        getAccounts(1000);
        RetreatLessons(id);
        RetreatMonks(id);
        getFeedbackForRetreat(id);
        getTools();
    }, []);



    useEffect(() => {
        GetRetreatID(id);
    }, []);

    const onFinish = (values) => {
        console.log(values)
        const formData = new FormData();
        formData.append('name', values.name);
        formData.append('cost', values.cost);
        formData.append('capacity', values.capacity);
        formData.append('duration', values.duration);
        formData.append('description', description);
        formData.append('status', values.status);
        console.log(Retreat?.startDate)
        console.log(dayjs(values.startDate).format('YYYY-MM-DD'))
        if (Retreat?.startDate !== dayjs(values.startDate).format('YYYY-MM-DD')) {
            formData.append('startDate', dayjs(values.startDate).format('YYYY-MM-DD'));
        }
        if (selectedTools && selectedTools.length > 0) {
            selectedTools.forEach(toolIds => {
                formData.append('toolIds', toolIds);
            });
        }
        values.retreatLearningOutcomes?.forEach(outcome => {
            formData.append('learningOutcome', JSON.stringify({
                title: outcome.title,
                subTitle: outcome.subTitle,
                description: outcome.description
            }));
        });

        if (values.images) {
            values.images.forEach((image, index) => {
                if (image.originFileObj) {
                    formData.append('images', image.originFileObj);
                }
            });
        }

        if (values.documents) {
            values.documents.forEach((doc, index) => {
                if (doc.originFileObj) {
                    formData.append('documents', doc.originFileObj);
                }
            });
        }
        for (let [key, value] of formData.entries()) {
            console.log(`${key}:`, value);
        }
        setLoading(true);
        UpdateRetreat(id, formData)
            .then(res => {
                if (res.status === 201) {
                    notification.success({
                        message: "Update Retreat Successfully"
                    });
                    setEdit(false);
                    form.setFieldsValue({
                        images: [],
                        documents: []
                    });
                    setLoading(false);
                    GetRetreatID(id);
                }
            })
            .catch(err => {
                console.log(err);
                notification.error({
                    message: `${err.response.data.message}`
                });
                setLoading(false);
            })

    };

    const handleToolSelect = (selectedRowKeys) => {
        setSelectedTools(selectedRowKeys);
    };

    const getSelectedToolIds = () => {
        const selectedTools = form.getFieldValue('retreatTools') || [];
        return selectedTools.map(tool => tool.tool.id);
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleSaveTools = () => {
        console.log("Selected Tools: ", selectedTools);
        setIsModalVisible(false);
    };

    const handleAddMonk = () => {
        setIsAddMonkModalVisible(true); // Show the modal instead of adding monk directly
    };

    const columns = [
        {
            title: 'Tool Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Quantity',
            dataIndex: 'totalTool',
            key: 'totalTool',
        },
    ];

    return (
        <div>
            <Button
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(-1)}
                style={{ marginBottom: 16 }}
            >
                Go Back
            </Button>

            <div style={{ margin: 'auto', padding: '24', maxWidth: '90%' }}>
                <h1 style={{ fontSize: '2.5rem', marginBottom: 16, fontWeight: 'bold', textAlign: 'left', color: '#003366' }}>RETREAT DETAIL INFORMATION</h1>
                {Edit && Retreat?.status !== "InActive" ? (
                    <>

                        <Form
                            onFinish={onFinish}
                            form={form}
                        >
                            <Row gutter={16}>

                                <Col span={12}>
                                    <Card title="General Information" style={{ marginBottom: 16 }}>
                                        <Form.Item name={"name"} label="Retreat Name" rules={[{ required: true, message: 'Requiring Retreat Name' }]}>
                                            <Input placeholder="Input Retreat Name" />
                                        </Form.Item>
                                        <Form.Item name={"cost"} label="Cost" rules={[{ required: true, message: 'Requiring cost' }]}>
                                            <InputNumber min={1} style={{ width: '100%' }} placeholder="Input Cost" />
                                        </Form.Item>
                                        <Form.Item name={"capacity"} label="Capacity" rules={[{ required: true, message: 'Requiring capacity' }]}>
                                            <InputNumber min={1} style={{ width: '100%' }} placeholder="Input Capacity" />
                                        </Form.Item>
                                        <Form.Item name={"duration"} label="Duration" rules={[{ required: true, message: 'Requiring duration' }]}>
                                            <InputNumber min={1} style={{ width: '100%' }} placeholder="Input Duration" />
                                        </Form.Item>
                                    </Card>
                                </Col>

                                <Col span={12}>
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <Card title="Date" style={{ marginBottom: 16 }}>
                                                <Form.Item name={"startDate"} label="Start Date" rules={[{ required: true }]}>
                                                    <DatePicker placeholder="Select Start Date" style={{ width: '100%' }} />
                                                </Form.Item>
                                            </Card>
                                        </Col>

                                        <Col span={24}>
                                            <Card title="Status" style={{ marginBottom: 16 }}>
                                                <Form.Item name={"status"} label={<span style={{ fontSize: '16px' }}>Status</span>}>
                                                    <Select
                                                        placeholder="Select Status"
                                                    >
                                                        {(Retreat?.status === "Close") ? (
                                                            <Option key={1} value="Active">
                                                                Active
                                                            </Option>
                                                        ) : (
                                                            <Option key={2} value="InActive">
                                                                InActive
                                                            </Option>
                                                        )}
                                                    </Select>
                                                    {/* <Tag
                                                        style={{ fontSize: 14, padding: '8px 20px' }}
                                                        color={form.getFieldValue('status') === 'Open' ? 'green' : (form.getFieldValue('status') === 'Close' ? 'red' : (form.getFieldValue('status') === 'Active' ? 'blue' : 'gray'))}>
                                                        {form.getFieldValue('status')}
                                                    </Tag> */}
                                                </Form.Item>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col span={24}>
                                    <Card title="Description" style={{ marginBottom: 16, minHeight: '620px' }}>
                                        <Form.Item rules={[{ required: true, message: 'Requiring Description' }]}>
                                            <div style={{ height: '480px' }}>
                                                <ReactQuill
                                                    value={description}
                                                    onChange={setDescription}
                                                    placeholder="Input Description"
                                                    modules={{
                                                        toolbar: [
                                                            ['bold', 'link', { list: 'ordered' }, { list: 'bullet' }],
                                                            [{ 'header': [1, 2, false] }],
                                                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                                                            [{ 'direction': 'rtl' }],
                                                            ['image']
                                                        ]
                                                    }}
                                                    formats={[
                                                        'bold', 'link', 'list', 'header', 'indent', 'direction', 'image'
                                                    ]}
                                                    style={{ height: '100%' }}
                                                />
                                            </div>
                                        </Form.Item>
                                    </Card>
                                </Col>
                                <Col span={12}>
                                    <Card title="Retreat Documents" style={{ marginBottom: 16 }}>
                                        <Form.Item name="documents" getValueFromEvent={(e) => {
                                            if (Array.isArray(e)) {
                                                return e;
                                            }
                                            return e?.fileList;
                                        }}>
                                            <Upload listType="text" maxCount={2} beforeUpload={() => false} accept=".doc,.docx,.pdf">
                                                <Button icon={<UploadOutlined />}>Upload Document</Button>
                                            </Upload>
                                        </Form.Item>
                                    </Card>
                                </Col>

                                <Col span={12}>
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <Card title="Image" style={{ marginBottom: 16 }}>
                                                <Form.Item name="images" label="Image" valuePropName="fileList" getValueFromEvent={(e) => {
                                                    if (Array.isArray(e)) {
                                                        return e;
                                                    }
                                                    return e?.fileList;
                                                }}>
                                                    <Upload listType="picture-card"
                                                        maxCount={2}
                                                        beforeUpload={() => false}
                                                        accept="image/*"

                                                    >
                                                        <div>
                                                            <PlusOutlined />
                                                            <div style={{ marginTop: 8 }}>Upload</div>
                                                        </div>
                                                    </Upload>
                                                </Form.Item>
                                            </Card>
                                        </Col>


                                    </Row>
                                </Col>

                                {/* Learning Outcomes */}
                                <Col span={24}>
                                    <Form.List name="retreatLearningOutcomes">
                                        {(fields, { add, remove }) => (
                                            <Card title="Learning Outcomes" style={{ marginBottom: 16 }}>
                                                {fields.map(({ key, name, ...restField }) => (
                                                    <div key={key} style={{ marginBottom: 16, border: '1px solid #d9d9d9', padding: 16, borderRadius: 8 }}>
                                                        <Row gutter={16}>
                                                            <Col span={12}>
                                                                <Form.Item {...restField} name={[name, 'title']} label="Title" rules={[{ required: true, message: 'Title is required' }]}>
                                                                    <Input placeholder="Enter title" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={12}>
                                                                <Form.Item {...restField} name={[name, 'subTitle']} label="Subtitle" rules={[{ required: true, message: 'Subtitle is required' }]}>
                                                                    <Input placeholder="Enter subtitle" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={24}>
                                                                <Form.Item {...restField} name={[name, 'description']} label="Description" rules={[{ required: true, message: 'Description is required' }]}>
                                                                    <Input.TextArea rows={3} placeholder="Enter description" />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Button type="link" danger onClick={() => remove(name)} icon={<MinusCircleOutlined />}>
                                                            Remove this outcome
                                                        </Button>
                                                    </div>
                                                ))}
                                                <Form.Item>
                                                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                                        Add Learning Outcome
                                                    </Button>
                                                </Form.Item>
                                            </Card>
                                        )}
                                    </Form.List>
                                </Col>
                            </Row>

                            <Form.Item name="lessonSelect" label="Select Lesson">
                                <Select
                                    placeholder="Choose a lesson"
                                    onChange={value => setSelectedLesson(value)}
                                >
                                    {Lesson.map(lesson => (
                                        <Option key={lesson.id} value={lesson.id}>
                                            {lesson.title}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Button type="dashed" onClick={handleAddLesson} block icon={<PlusOutlined />}>
                                Add Lesson
                            </Button>

                            <Card title="Retreat Lessons" style={{ marginTop: 16 }}>
                                <List
                                    dataSource={retreatLessons}
                                    renderItem={(item) => (
                                        <List.Item>
                                            <List.Item.Meta
                                                title={<Typography.Text>{`Title: ${item.lessonTitle}`}</Typography.Text>}
                                                description={<Typography.Text>{`Author: ${item.authorFirstName} ${item.authorLastName}`}</Typography.Text>}
                                            />
                                            <Button type="primary" onClick={() => handleDeleteLesson(item.id)} style={{ backgroundColor: 'red' }}>
                                                Delete
                                            </Button>
                                        </List.Item>
                                    )}
                                    bordered
                                    style={{
                                        backgroundColor: '#fafafa',
                                        borderRadius: '6px',
                                    }}
                                />
                            </Card>

                            <Form.Item>
                                <Button block type="primary" htmlType="submit" loading={loading}>
                                    {loading ? "Loading" : "Confirm Update"}
                                </Button>
                            </Form.Item>
                        </Form>
                    </>
                ) : (
                    <>
                        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'left' }}>
                            <div style={{ marginRight: 10 }}>
                                <Button type="primary" onClick={() => handleEditClick()}>
                                    Edit Retreat
                                </Button>
                            </div>
                            <div style={{ marginRight: 10 }}>
                                <Button type="primary" onClick={showModal}>
                                    Update Tool
                                </Button>
                            </div>
                            <Button type="primary" onClick={handleAddMonk}>
                                Update Monk
                            </Button>
                        </div>
                        <Form
                            form={form}
                            name="wrap"
                            labelAlign="left"
                            labelWrap
                            labelCol={{ flex: '150px' }}
                        >
                            <Row gutter={16}>

                                <Col span={12}>
                                    <Card title="General Information" style={{ marginBottom: 16 }}>
                                        <Form.Item name={"name"} label={<span style={{ fontSize: '16px' }}>Retreat Name</span>}
                                            style={{ borderBottom: '1px solid #d9d9d9', padding: '8px' }}
                                        >
                                            <Input disabled
                                                style={{
                                                    border: 'none',
                                                    color: 'rgba(0, 0, 0, 0.88)',
                                                    width: '100%',
                                                    backgroundColor: 'white',
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item name={"cost"} label={<span style={{ fontSize: '16px' }}>Tuition Fee</span>}
                                            style={{ borderBottom: '1px solid #d9d9d9', padding: '8px' }}
                                        >
                                            <Input disabled
                                                style={{
                                                    border: 'none',
                                                    color: 'rgba(0, 0, 0, 0.88)',
                                                    width: '100%',
                                                    backgroundColor: 'white',
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item name={"capacity"} label={<span style={{ fontSize: '16px' }}>Capacity</span>}
                                            style={{ borderBottom: '1px solid #d9d9d9', padding: '8px' }}
                                        >
                                            <InputNumber disabled
                                                style={{
                                                    border: 'none',
                                                    color: 'rgba(0, 0, 0, 0.88)',
                                                    width: '100%',
                                                    backgroundColor: 'white',
                                                }}
                                            />
                                        </Form.Item>
                                        <Form.Item name={"duration"} label={<span style={{ fontSize: '16px' }}>Duration</span>}
                                            style={{ padding: '8px' }}
                                        >
                                            <InputNumber disabled
                                                style={{
                                                    border: 'none',
                                                    color: 'rgba(0, 0, 0, 0.88)',
                                                    width: '100%',
                                                    backgroundColor: 'white',
                                                }}
                                            />
                                        </Form.Item>
                                    </Card>
                                </Col>

                                <Col span={12}>
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <Card title="Date" style={{ marginBottom: 16 }}>
                                                <Form.Item name={"startDate"} label="Start Date">
                                                    <DatePicker disabled
                                                    />
                                                </Form.Item>
                                                <Form.Item name={"endDate"} label="End Date">
                                                    <DatePicker disabled
                                                    />
                                                </Form.Item>
                                            </Card>
                                        </Col>

                                        <Col span={24}>
                                            <Card title="Status" style={{ marginBottom: 16 }}>
                                                <Form.Item name={"status"} label={<span style={{ fontSize: '16px' }}>Status</span>}>
                                                    <Tag
                                                        style={{ fontSize: 14, padding: '8px 20px' }}
                                                        color={form.getFieldValue('status') === 'Open' ? 'green' : (form.getFieldValue('status') === 'Close' ? 'red' : (form.getFieldValue('status') === 'Active' ? 'blue' : 'gray'))}>
                                                        {form.getFieldValue('status')}
                                                    </Tag>
                                                </Form.Item>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col span={24}>
                                    <Card title="Description" style={{ marginBottom: 16, minHeight: '96.5%', maxHeight: '96.5%' }}>
                                        <Form.Item name={"description"}>
                                            <div
                                                style={{
                                                    backgroundColor: '#fafafa',
                                                    border: '1px solid #d9d9d9',
                                                    borderRadius: '6px',
                                                    minHeight: '32px',
                                                    color: 'rgba(0, 0, 0, 0.88)',
                                                    maxHeight: '1000px',
                                                    overflowY: 'auto',
                                                    overflowX: 'hidden',
                                                }}
                                                dangerouslySetInnerHTML={{
                                                    __html: form.getFieldValue('description') || ''
                                                }}
                                            />
                                        </Form.Item>
                                    </Card>
                                </Col>
                                <Col span={12}>
                                    <Card title="Retreat Documents" style={{ marginBottom: 16 }}>
                                        <Form.Item name="retreatDocuments">
                                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                                {form.getFieldValue('retreatDocuments') !== undefined && form.getFieldValue('retreatDocuments').length > 0 ? (
                                                    form.getFieldValue('retreatDocuments')?.map((doc, index) => (
                                                        <Link
                                                            key={index}
                                                            href={doc.url}
                                                            target="_blank"
                                                            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                                        >
                                                            <i className="fas fa-file-word" style={{ color: '#2B579A' }}></i>
                                                            {doc.fileName || `Document ${index + 1}`}
                                                        </Link>
                                                    ))
                                                ) : (
                                                    <div>
                                                        No Document Available
                                                    </div>
                                                )}

                                            </div>
                                        </Form.Item>
                                    </Card>
                                </Col>

                                <Col span={12}>
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <Card title="Image" style={{ marginBottom: 16 }}>
                                                <Form.Item name="retreatImages" >
                                                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                                        {form.getFieldValue('retreatImages')?.map((image, index) => (
                                                            <Image
                                                                key={index}
                                                                src={image.url}
                                                                alt={`Retreat image ${index + 1}`}
                                                                style={{ width: 200, height: 200, objectFit: 'cover' }}
                                                            />
                                                        ))}
                                                    </div>
                                                </Form.Item>
                                            </Card>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col span={24}>


                                    {form.getFieldValue('retreatTools') !== undefined && form.getFieldValue('retreatTools').length > 0 ? (
                                        <Card title="Tools borrowed" style={{ marginTop: 16, marginBottom: 16 }}>
                                            <List
                                                dataSource={form.getFieldValue('retreatTools')}
                                                renderItem={(item) => (
                                                    <List.Item>
                                                        <div style={{ width: '100%' }}>
                                                            <Typography.Text>{`Tool: ${item.tool.name}`}</Typography.Text><br />
                                                            <Typography.Text>{`Quantiy: ${item.quantity}`}</Typography.Text>
                                                        </div>
                                                    </List.Item>
                                                )}
                                                bordered
                                                style={{
                                                    backgroundColor: '#fafafa',
                                                    borderRadius: '6px',
                                                }}
                                            />
                                        </Card>
                                    ) : (
                                        <Card title="Tools borrowed" style={{ marginTop: 16, marginBottom: 16 }}>
                                            <div>No Tool Available</div>
                                        </Card>
                                    )
                                    }
                                    {retreatMonks.length > 0 ? (
                                        <Card title="Retreat Monks" style={{ marginTop: 16, marginBottom: 16 }}>
                                            <List
                                                dataSource={retreatMonks}
                                                renderItem={(item) => (
                                                    <List.Item>
                                                        <div style={{ width: '100%' }}>
                                                            <Typography.Text>{`Name : ${item.monk.firstName} ${item.monk.lastName}`}</Typography.Text><br />
                                                            <Typography.Text>{`Phone : ${item.monk.phoneNumber}`}</Typography.Text><br />
                                                            <Typography.Text>{`Email : ${item.monk.email}`}</Typography.Text>
                                                        </div>
                                                    </List.Item>
                                                )}
                                                bordered
                                                style={{
                                                    backgroundColor: '#fafafa',
                                                    borderRadius: '6px',
                                                }}
                                            />
                                        </Card>
                                    ) : (
                                        <Card title="Retreat Monks" style={{ marginTop: 16, marginBottom: 16 }}>
                                            <div>No Monk Available</div>
                                        </Card>
                                    )
                                    }
                                    {retreatLessons.length > 0 ? (
                                        <Card title="Retreat Lessons" style={{ marginTop: 16 }}>
                                            <List
                                                dataSource={retreatLessons}
                                                renderItem={(item) => (
                                                    <List.Item>
                                                        <div style={{ width: '100%' }}>
                                                            <Typography.Text>{`Title: ${item.lessonTitle}`}</Typography.Text>
                                                            <Typography.Text>{` | Author: ${item.authorFirstName} ${item.authorLastName}`}</Typography.Text>
                                                        </div>
                                                    </List.Item>
                                                )}
                                                bordered
                                                style={{
                                                    backgroundColor: '#fafafa',
                                                    borderRadius: '6px',
                                                }}
                                            />
                                        </Card>
                                    ) : (
                                        <Card title="Retreat Lessons" style={{ marginTop: 16, marginBottom: 16 }}>
                                            <div>No Lesson Available</div>
                                        </Card>
                                    )
                                    }


                                    <Card title="Rating" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20, marginTop: 16 }}>
                                        {Feedback.length > 0 ? (
                                            <div style={{ width: '100%', height: '400px', display: 'flex', justifyContent: 'center' }}>
                                                <FeedbackBarChart feedback={Feedback} />
                                            </div>
                                        ) : (
                                            <div>No Rating Available</div>
                                        )}
                                    </Card>
                                    {Feedback.length > 0 ? (
                                        <Card title="Feedback" style={{ border: '1px solid #d9d9d9', borderRadius: '4px', marginBottom: 20, marginTop: 16 }}>
                                            <List
                                                itemLayout="vertical"
                                                dataSource={Feedback}
                                                renderItem={feedback => (
                                                    <List.Item key={feedback.id}>
                                                        <List.Item.Meta
                                                            avatar={<Avatar src={feedback.createdBy.avatar} size={60} />}
                                                            title={<span style={{ fontSize: '1rem', fontWeight: 'bold' }}>{`${feedback.createdBy.firstName} ${feedback.createdBy.lastName}`}</span>}
                                                            description={<div>Experience : {feedback.yourExperience}</div>}
                                                        />
                                                       
                                                            {feedback.suggestion ? (
                                                                <div>Suggestion : {feedback.suggestion}</div>
                                                            ) : (<></>)}
                                                            <div>Created Date : {dayjs(feedback.updateAt).format('YYYY-MM-DD')}</div>
                                                        


                                                    </List.Item>
                                                )}
                                            />
                                        </Card>
                                    ) : (
                                        <></>
                                    )}

                                </Col>
                            </Row>

                        </Form>
                    </>
                )}
            </div>

            {/* Modal for selecting tools */}
            <Modal
                title="Select Tools"
                open={isModalVisible}
                onOk={() => {
                    form.validateFields().then(values => {
                        onFinish(values);
                        handleSaveTools();
                    }).catch(info => {
                        console.log('Validate Failed:', info);
                    });
                }}
                onCancel={() => setIsModalVisible(false)}
                width={800}
            >
                <Table
                    rowSelection={{
                        type: 'checkbox',
                        selectedRowKeys: selectedTools.length > 0 ? selectedTools : getSelectedToolIds(),
                        onChange: handleToolSelect,
                    }}
                    columns={columns}
                    dataSource={ToolData}
                    rowKey="id"
                    pagination={false}
                />
            </Modal>

            <Modal
                title="Update Monk"
                open={isAddMonkModalVisible}
                onCancel={() => setIsAddMonkModalVisible(false)}
                footer={[
                    <Button key="cancel" onClick={() => setIsAddMonkModalVisible(false)}>
                        Cancel
                    </Button>,
                    <Button key="custom" type="primary" onClick={confirmAddMonk} loading={loading}>
                        {loading ? "Loading" : "OK"}
                    </Button>

                ]}
            >
                <Select
                    placeholder="Choose a monk"
                    onChange={value => setSelectedMonk(value)}
                    style={{ width: '100%' }}
                >
                    {Monk.map(monk => (
                        <Option key={monk.id} value={monk.id}>
                            {`${monk.firstName} ${monk.lastName}`}
                        </Option>
                    ))}
                </Select>
            </Modal>
        </div >
    )

}
export default AdminDetailRetreat